var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 151,
    viewBox: "0 0 171 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.31502 6.64954C5.14586 6.64954 6.63005 5.16099 6.63005 3.32477C6.63005 1.48855 5.14586 0 3.31502 0C1.48419 0 0 1.48855 0 3.32477C0 5.16099 1.48419 6.64954 3.31502 6.64954Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4764 6.64954C46.3072 6.64954 47.7914 5.16099 47.7914 3.32477C47.7914 1.48855 46.3072 0 44.4764 0C42.6456 0 41.1614 1.48855 41.1614 3.32477C41.1614 5.16099 42.6456 6.64954 44.4764 6.64954Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3621 6.64954C87.193 6.64954 88.6772 5.16099 88.6772 3.32477C88.6772 1.48855 87.193 0 85.3621 0C83.5313 0 82.0471 1.48855 82.0471 3.32477C82.0471 5.16099 83.5313 6.64954 85.3621 6.64954Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.524 6.64954C128.354 6.64954 129.839 5.16099 129.839 3.32477C129.839 1.48855 128.354 0 126.524 0C124.693 0 123.209 1.48855 123.209 3.32477C123.209 5.16099 124.693 6.64954 126.524 6.64954Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171 3.32477C171 5.26422 169.619 6.64954 167.685 6.64954C165.751 6.64954 164.37 5.26422 164.37 3.32477C164.37 1.38532 165.751 0 167.685 0C169.343 0 171 1.38532 171 3.32477Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31502 42.6679C5.14586 42.6679 6.63005 41.1793 6.63005 39.3431C6.63005 37.5069 5.14586 36.0183 3.31502 36.0183C1.48419 36.0183 0 37.5069 0 39.3431C0 41.1793 1.48419 42.6679 3.31502 42.6679Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4764 42.6679C46.3072 42.6679 47.7914 41.1793 47.7914 39.3431C47.7914 37.5069 46.3072 36.0183 44.4764 36.0183C42.6456 36.0183 41.1614 37.5069 41.1614 39.3431C41.1614 41.1793 42.6456 42.6679 44.4764 42.6679Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3621 42.6679C87.193 42.6679 88.6772 41.1793 88.6772 39.3431C88.6772 37.5069 87.193 36.0183 85.3621 36.0183C83.5313 36.0183 82.0471 37.5069 82.0471 39.3431C82.0471 41.1793 83.5313 42.6679 85.3621 42.6679Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M126.524 42.6679C128.354 42.6679 129.839 41.1793 129.839 39.3431C129.839 37.5069 128.354 36.0183 126.524 36.0183C124.693 36.0183 123.209 37.5069 123.209 39.3431C123.209 41.1793 124.693 42.6679 126.524 42.6679Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M171 39.3431C171 41.2825 169.619 42.6679 167.685 42.6679C165.751 42.6679 164.37 41.2825 164.37 39.3431C164.37 37.4036 165.751 36.0183 167.685 36.0183C169.343 36.0183 171 37.6807 171 39.3431Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31502 78.9625C5.14586 78.9625 6.63005 77.474 6.63005 75.6378C6.63005 73.8015 5.14586 72.313 3.31502 72.313C1.48419 72.313 0 73.8015 0 75.6378C0 77.474 1.48419 78.9625 3.31502 78.9625Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4764 78.9625C46.3072 78.9625 47.7914 77.474 47.7914 75.6378C47.7914 73.8015 46.3072 72.313 44.4764 72.313C42.6456 72.313 41.1614 73.8015 41.1614 75.6378C41.1614 77.474 42.6456 78.9625 44.4764 78.9625Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3621 78.9625C87.193 78.9625 88.6772 77.474 88.6772 75.6378C88.6772 73.8015 87.193 72.313 85.3621 72.313C83.5313 72.313 82.0471 73.8015 82.0471 75.6378C82.0471 77.474 83.5313 78.9625 85.3621 78.9625Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M126.524 78.9625C128.354 78.9625 129.839 77.474 129.839 75.6378C129.839 73.8015 128.354 72.313 126.524 72.313C124.693 72.313 123.209 73.8015 123.209 75.6378C123.209 77.474 124.693 78.9625 126.524 78.9625Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M171 75.6378C171 77.5772 169.619 78.9625 167.685 78.9625C165.751 78.9625 164.37 77.5772 164.37 75.6378C164.37 73.6983 165.751 72.313 167.685 72.313C169.343 72.313 171 73.6983 171 75.6378Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31502 114.981C5.14586 114.981 6.63005 113.493 6.63005 111.656C6.63005 109.82 5.14586 108.332 3.31502 108.332C1.48419 108.332 0 109.82 0 111.656C0 113.493 1.48419 114.981 3.31502 114.981Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4764 114.981C46.3072 114.981 47.7914 113.493 47.7914 111.656C47.7914 109.82 46.3072 108.332 44.4764 108.332C42.6456 108.332 41.1614 109.82 41.1614 111.656C41.1614 113.493 42.6456 114.981 44.4764 114.981Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3621 114.981C87.193 114.981 88.6772 113.493 88.6772 111.656C88.6772 109.82 87.193 108.332 85.3621 108.332C83.5313 108.332 82.0471 109.82 82.0471 111.656C82.0471 113.493 83.5313 114.981 85.3621 114.981Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M126.524 114.981C128.354 114.981 129.839 113.493 129.839 111.656C129.839 109.82 128.354 108.332 126.524 108.332C124.693 108.332 123.209 109.82 123.209 111.656C123.209 113.493 124.693 114.981 126.524 114.981Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M171 111.656C171 113.596 169.619 114.981 167.685 114.981C165.751 114.981 164.37 113.596 164.37 111.656C164.37 109.717 165.751 108.332 167.685 108.332C169.343 108.332 171 109.717 171 111.656Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63005 147.675C6.63005 149.614 5.24879 150.999 3.31502 150.999C1.38126 150.999 0 149.614 0 147.675C0 145.735 1.38126 144.35 3.31502 144.35C5.24879 144.35 6.63005 146.012 6.63005 147.675Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7914 147.675C47.7914 149.614 46.4102 150.999 44.4764 150.999C42.5426 150.999 41.1614 149.614 41.1614 147.675C41.1614 145.735 42.5426 144.35 44.4764 144.35C46.1339 144.35 47.7914 146.012 47.7914 147.675Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6772 147.675C88.6772 149.614 87.2959 150.999 85.3621 150.999C83.4284 150.999 82.0471 149.614 82.0471 147.675C82.0471 145.735 83.4284 144.35 85.3621 144.35C87.2959 144.35 88.6772 146.012 88.6772 147.675Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M129.839 147.675C129.839 149.614 128.457 150.999 126.524 150.999C124.59 150.999 123.209 149.614 123.209 147.675C123.209 145.735 124.59 144.35 126.524 144.35C128.457 144.35 129.839 146.012 129.839 147.675Z",
    fill: "#115896",
    fillOpacity: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M171 147.675C171 149.614 169.619 150.999 167.685 150.999C165.751 150.999 164.37 149.614 164.37 147.675C164.37 145.735 165.751 144.35 167.685 144.35C169.343 144.35 171 146.012 171 147.675Z",
    fill: "#115896",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/Frame2.44a40b71482c52bc1172fa7b327c47e1.svg";
export { ForwardRef as ReactComponent };